import { createChallengeSdk } from '../vendors/zero-trust-challenge-sdk/index.js'

const CHALLENGE_URL = String(
  process.env.VUE_APP_CHALLENGE_URL || '/gateway/challenge'
).trim()

const CHALLENGE_RESPONSE_CODES = new Set([
  'CHALLENGE_BAD_REQUEST',
  'CHALLENGE_EXPIRED',
  'CHALLENGE_INVALID',
  'CHALLENGE_INVALID_TIME',
  'CHALLENGE_NONCE_REPLAY',
  'CHALLENGE_POW_INVALID',
  'CHALLENGE_RATE_LIMITED',
  'CHALLENGE_SIGNATURE_INVALID',
  'CHALLENGE_UNSUPPORTED_VERSION'
])

let challengeSdk = null

async function shouldHandleChallengeResponse(response) {
  if (![400, 401, 403].includes(response.status)) return false

  const rawText = await response.text().catch(() => '')
  if (!rawText) return false

  try {
    const body = JSON.parse(rawText)
    return typeof body?.code === 'string' && CHALLENGE_RESPONSE_CODES.has(body.code)
  } catch (_) {
    return false
  }
}

export function getChallengeSdk() {
  if (!challengeSdk) {
    const boundFetch = window.fetch.bind(window)
    challengeSdk = createChallengeSdk({
      challengeUrl: CHALLENGE_URL,
      challengeMode: 'lazy',
      challengeFetch: boundFetch,
      businessFetch: boundFetch,
      shouldHandleChallengeResponse
    })
  }

  return challengeSdk
}
